import React from 'react';
import { AssistantContextContainerProps } from './interviewContextProps';
import {
    AssistantContextProvider,
    AssistantContextController,
    AssistantContextLoader,
} from './interviewContextInterface';
import { UnauthenticatedApplicationContext } from '@varos/client-base';
import { AssistantContainerBaseConfig } from '../../base';

export function createContextContainer(
    config: AssistantContainerBaseConfig,
    provider: AssistantContextProvider,
    loader: AssistantContextLoader,
    controller: AssistantContextController
): React.FC<AssistantContextContainerProps> {
    const { adapter } = config;
    const { Provider } = provider;

    const context: UnauthenticatedApplicationContext = {
        principal: null,
    };

    return ({ children, ...containerProps }) => {
        const user = adapter.user.useUser();
        const item = loader.useLoad(context);
        const props = controller.useProps(item, { user });
        return <Provider value={props.value}>{children}</Provider>;
    };
}
